import { useEffect, useState } from 'react';
import { LeftComponentLabel, switchWithLabel } from './settingsCommon';
import { useDispatch, useSelector } from 'react-redux';
import SelectNavBox from '../../components/common/SelectNavBox';
import PillSwitch from '../../components/common/PillSwitch';
import ModalNewUI from '../../components/ui/Modals/ModalMessages/ModalNewUI';
import { getDomainSelcted } from '../../services/storage/LocalStorage';
import { THURAYA_DOMAIN_NAMES } from '../../state/constants';
import ChangePasswordModal from '../../components/ui/Modals/SettingsModals/ChangePasswordModal';
import { updateMFAStatus, updateSoftwareMfaEnabled, updateSoftwareMfaStatus } from '../../state/actions/user';
import TwoFactorAuthModal from '../../components/ui/Modals/SettingsModals/TwoFactorAuthModal';
import { useNavigate } from 'react-router-dom';

const SecuritySettings = ({ updateUserData, userDataFromStore }) => {
  const selectedDomain = useSelector((state) => state.domain.selectedDomain)
  const [searchableCheck, setSearchableCheck] = useState(false)
  const [visibleCheck, setVisibleCheck] = useState(false)
  const [showChangePassModal, setShowChangePassModal] = useState(false)
  const [showTwoFactorAuthModal, setShowTwoFactorAuthModal] = useState(false)
  const userCurrentDomain = getDomainSelcted();

  //step 1,2,3 use to activate mfa 
  //step 4 use to deactivate mfa
  const [stepOf2FA, setStepOf2FA] = useState()
  const [headerContent2FA, setHeaderContent2FA] = useState("")
  const [subHeaderContent2FA, setSubHeaderContent2FA] = useState("")

  const softwareMfaEnabled = useSelector(state => state?.user?.user?.softwareMfaEnabled)

  const dispatch = useDispatch();

  useEffect(() => {
    if (softwareMfaEnabled) {
      setStepOf2FA(4)
    } else {
      setStepOf2FA(1)
    }
    if (userDataFromStore) {
      setSearchableCheck(userDataFromStore.searchable)
      setVisibleCheck(userDataFromStore.visible)
    }
  }, [])

  useEffect(() => {
    if (stepOf2FA === 1 || stepOf2FA === 4) {
      setHeaderContent2FA("To keep your onship account shipshape, ")
      const subHeaderContent = stepOf2FA === 1 ? "please reconfirm your password to enable two-factor authentication" : "Please confirm your password to deactivate"
      setSubHeaderContent2FA(subHeaderContent)
    }
    if (stepOf2FA === 2 || stepOf2FA === 3) {
      setHeaderContent2FA("")
      setSubHeaderContent2FA("")
    }
  }, [stepOf2FA])


  // useEffect(() => {
  //   switch2FA ? setShowTwoFactorAuthModal(true) : setShowTwoFactorAuthModal(false) 
  // },[switch2FA])

  const close2FaModal = () => {
    dispatch(updateMFAStatus(null))
    dispatch(updateSoftwareMfaStatus(null))
    setShowTwoFactorAuthModal(false)
    dispatch(updateSoftwareMfaEnabled(!softwareMfaEnabled))
  }

  const close2FaModalOnSuccess = () => {
    dispatch(updateMFAStatus(null))
    dispatch(updateSoftwareMfaStatus(null))
    setShowTwoFactorAuthModal(false)
  }

  const handle2faSwitch = () => {
    setShowTwoFactorAuthModal(true)
    if (!softwareMfaEnabled) {
      dispatch(updateSoftwareMfaEnabled(true))
      setStepOf2FA(1)
    } else {
      setStepOf2FA(4)
      dispatch(updateSoftwareMfaStatus('deactivate'))
      dispatch(updateSoftwareMfaEnabled(false))
    }
  }

  const handleSearchToggle = () => {
    setSearchableCheck(!searchableCheck);
    updateUserData('searchable', !searchableCheck);
  }

  const handleVisibleToggle = () => {
    setVisibleCheck(!visibleCheck);
    updateUserData('visible', !visibleCheck);
  }

  return (
    <>
      {!THURAYA_DOMAIN_NAMES.includes(userCurrentDomain?.name) &&
        <div className={`text-with-switch mt-4 ${selectedDomain}_font`}>
          <p className='text-with-switch-content'>{`I want to appear in ${selectedDomain} user directory search results`}</p>
          <div className='mb-3'>
            <PillSwitch size='small' checked={searchableCheck} onChange={handleSearchToggle} />
          </div>
        </div>
      }
      {!THURAYA_DOMAIN_NAMES.includes(userCurrentDomain?.name) &&
        <div className={`text-with-switch mt-2 ${selectedDomain}_font`}>
          <p className='text-with-switch-content'>{`I want to share my profile information with my contacts`}</p>
          <div className='mb-3'>
            <PillSwitch size='small' checked={visibleCheck} onChange={handleVisibleToggle} />
          </div>
        </div>
      }
      <SelectNavBox leftNavComponent={<LeftComponentLabel label={"Update Password"} />} customOnClickFn={() => setShowChangePassModal(true)}/>
      <SelectNavBox leftNavComponent={<LeftComponentLabel label={"Two-factor Authentication"} />} rightNavComponent={<PillSwitch size='small' checked={softwareMfaEnabled} onChange={handle2faSwitch} />} showNoCursorPointer={true} />

      {
        showChangePassModal &&
        <ModalNewUI open={showChangePassModal} onClose={() => setShowChangePassModal(false)} headerContent={"Change Password"}>
          <ChangePasswordModal onClose={() => setShowChangePassModal(false)} />
        </ModalNewUI>
      }

      {
        showTwoFactorAuthModal &&
        <ModalNewUI open={showTwoFactorAuthModal} custompadding={stepOf2FA === 3 ? "50px 30px 50px 65px" : "50px 40px 50px 65px"} onClose={close2FaModal} headerContent={headerContent2FA} subHeaderContent={subHeaderContent2FA}>
          <TwoFactorAuthModal stepOf2FA={stepOf2FA} setStepOf2FA={setStepOf2FA} close2FaModalOnSuccess={close2FaModalOnSuccess} />
        </ModalNewUI>
      }
    </>
  )
}

export default SecuritySettings